var _circle, _circle2, _circle3, _circle4, _circle5, _circle6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDrag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 16,
    viewBox: "0 0 24 24",
    fill: "#ccc",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 4,
    r: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 12,
    r: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 20,
    r: 2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 4,
    r: 2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 12,
    r: 2
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 20,
    r: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrag);
export default __webpack_public_path__ + "static/media/drag.56e05db49da9e84c7ce9f82ff76c530f.svg";
export { ForwardRef as ReactComponent };